import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

/**
 * Only the base UOM is constrained: it is an id from the UOM master list, so a
 * checked-but-empty base UOM has nothing to write. The free-text UOMs may be
 * left blank on purpose — a checked field with no value clears that column, the
 * same latitude the single-part UOM form gives.
 */
export const bulkUpdateUomsSchema = () =>
  yup.object().shape({
    uom: yup
      .object()
      .label(t('labelBaseUom'))
      .nullable()
      .when('editUom', {
        is: true,
        then: (schema) => schema.required(getEmptyErrorMessage(t('labelBaseUom'))),
      }),
  });
